import OrderSummaryInformationForm from "./order-summary-information";
import styles from "./order-summary.module.scss";
import OrderSummaryItemOrders from "./products/products";
import { Loader } from "components/commons";

const OrderSummaryForm = ({ loading, orderSummary }) => {
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className={styles.form}>
            <OrderSummaryInformationForm orderSummary={orderSummary} loading={loading} />
          </div>
          <div className={styles.itemProductContainer}>
            <OrderSummaryItemOrders orderSummary={orderSummary} />
          </div>
        </>
      )}
    </>
  );
};

export default OrderSummaryForm;
